module.exports = __webpack_public_path__ + "img/tc-162x230.cc012b87.jpg";